import { api } from '../../api';

function addTransactions(transactions) {
  return api.post('/transactions', transactions);
}

export { addTransactions };
